import React, { Component } from 'react'
import { View, ScrollView, SafeAreaView, StyleSheet } from 'react-native';
import { connect } from 'react-redux';

import { CaptionNormalDark, BodyNormalDark, ProfileAvatar, GraphRow } from '../../components';
import styles from '../../styles';
import { global, colors } from '../../const';
import { getRolename } from '../../functions';
import * as Actions from "../../action";

import splash_holder from "../../assets/placeholder.png";
import DoughnutChart from '../../components/DoughnutChart';
import ProgressStrength from '../../components/ProgressStrength';
import ProfileList from '../../components/profile/ProfileList';
import Header from '../../components/Header';
import localize from '../../localize';

class MemberProfile extends Component {

    static navigationOptions = () => {
        return {
            title: localize.profile
        }
    }

    constructor(props) {
        super(props);
        let id, data;
        if (!global.isNative) {
            const query = new URLSearchParams(props.location.search);
            id = query.get('id');
            data = props.location.state;
            if (!data) data = { id, nickname: query.get('nickname'), avatar: query.get('thumb'), role_type: query.get('role') }
        } else {
            data = props.navigation.state.params;
            id = data.id;
        }

        this.state = {
            Teams: [],
            userProgress: [],
            member: data || [],
            id
        }
    }

    componentDidMount() {
        this.getUserOrganization();
        this.getStrength();
    }

    getStrength = async () => {
        let response = await this.props.getStranth(this.state.id)
        if (response[0]) return this.setState({ userProgress: response[0] })
    }

    getUserOrganization = async () => {
        let response = await this.props.getUserTeams(this.state.id)
        this.setState({ Teams: response });
    }

    _memberProgress = () => {
        if (global.isNative) {
            return this.props.navigation.navigate("progress", { type: 0, id: this.state.member.id });
        } else {
            return this.props.history.push({
                pathname: "/dashboard/progress",
                state: { type: 0, id: this.state.member.id },
                search: `?type=0&id=${this.state.member.id}`
            })
        }
    }


    render() {
        const { userProgress, Teams, member } = this.state;
        let userRole = getRolename(member.role_type);

        return (
            <View style={styles.container}>
                {
                    !global.isNative && (<Header title={localize.profile} goBack={() => this.props.history.goBack()} />)
                }
                <ScrollView style={!global.isNative && { height: this.props.setting.height - 70 }}>

                    <View style={{ height: 170, justifyContent: 'center', alignItems: 'center', marginBottom: 15 }}>
                        <View style={{ width: 130, height: 130 }}>
                            <ProfileAvatar src={member.avatar ? { uri: global.MAKEURL(member.avatar) } : splash_holder} />
                        </View>
                    </View>

                    <View>
                        <View style={[{ height: 1, width: '100%' }, styles.bglightGray]} />
                        <View style={{ justifyContent: "center", marginHorizontal: 10, paddingVertical: 10, flexDirection: 'row' }}>
                            <View style={{ alignItems: 'center' }}>
                                <CaptionNormalDark title={localize.Name} />
                                <BodyNormalDark title={member.nickname} />
                            </View>

                        </View>
                        <View style={[{ height: 1, width: '100%' }, styles.bglightGray]} />
                    </View>
                    <View>
                        <View style={{ justifyContent: "center", marginHorizontal: 10, paddingVertical: 10, flexDirection: 'row' }}>
                            <View style={{ alignItems: 'center' }}>
                                <CaptionNormalDark title={localize.PLAYER_TYPE} />
                                <BodyNormalDark title={userRole} />
                            </View>
                        </View>
                        <View style={[{ height: 1, width: '100%' }, styles.bglightGray]} />
                    </View>

                    <View style={{ padding: 20 }}>
                        <ProgressStrength
                            progress={userProgress.strength}
                            start={userProgress.maxLevel}
                            end={userProgress.minLevel}
                            title={localize.strengths}
                            onPress={this._memberProgress}
                        />
                    </View>
                    <View style={[{ height: 1, width: '100%' }, styles.bglightGray]} />

                    <View style={{ paddingVertical: 10 }}>
                        <DoughnutChart
                            data={userProgress}
                            title={localize.My_XP}
                        />
                    </View>

                    <View>
                        <GraphRow title={localize.character} progress={userProgress.character} color="#00c221" />
                        <GraphRow title={localize.life_experience} progress={userProgress.life_experience} color="#5e23ff" />
                        <GraphRow title={localize.financial} progress={userProgress.financial} color="#ffd000" />
                        <GraphRow title={localize.health_wellness} progress={userProgress.health} color="#ff0048" />
                    </View>

                    <View style={[{ height: 1, width: '100%', marginTop: 15 }, styles.bglightGray]} />

                    <View>
                        {Teams.map((item, i) => (
                            <ProfileList
                                data={item}
                                key={String(i)}
                                type="team"
                                props={this.props}
                            />))}
                    </View>

                </ScrollView>

            </View>
        )
    }
}

const mapStateToProps = ({ setting, auth }) => {
    return {
        setting: setting,
        userInfo: auth.userInfo,
    }
}
const mapDispatch = (dispatch) => {
    return {
        getUserTeams: id => dispatch(Actions.getUserTeams(id)),
        getStranth: (id) => dispatch(Actions.getStranth(id)),
    }
}
export default connect(mapStateToProps, mapDispatch)(MemberProfile);

const pageStyles = StyleSheet.create({
    avatarContainer: {
        height: 170,
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 15,
        backgroundColor: colors.white
    },
    userAvatar: {
        width: 130,
        height: 130,
        alignItems: 'center',
        justifyContent: "center"
    },
    divider: {
        height: 1,
        backgroundColor: colors.lightGray,
        width: '100%'
    },
    profileTitle: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: colors.white,
        padding: 10
    },
    smallTitle: {
        color: colors.midnightBack,
        fontSize: 13,
        fontFamily: global.FONT_REGULAR,
    },
    bigTitle: {
        color: colors.midnightBack,
        fontSize: 18,
        fontFamily: global.FONT_REGULAR,
    },
    linkTitle: {
        textDecorationLine: 'underline',
        fontFamily: global.FONT_REGULAR,
        fontWeight: "400",
        fontSize: 13,
        textTransform: 'uppercase',
        color: colors.indigo
    },
    progressArea: {
        backgroundColor: colors.white,
        padding: 20
    },
    progressHeading: {
        paddingBottom: 15,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row'
    },
    progressChart: {
        paddingVertical: 20,
        backgroundColor: colors.white
    },
    dontChartRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 50,
        paddingTop: 15,
        paddingHorizontal: 30
    },
    chartColorLable: {
        height: 12,
        width: 18,
        borderRadius: 4,
        marginRight: 6
    },
    row: {
        alignItems: "center",
        flexDirection: "row"
    },
    buttonArea: {
        width: '60%',
        paddingVertical: 20
    },
    rowCenter: {
        justifyContent: 'center',
        alignItems: 'center',
    },

})